import * as React from "react";
import TeamCards from "./TeamCards";
import Team from "../commons/model/Team";
import ModalAddTeam from "./ModalAddTeam";
import HeaderBar from "../commons/components/HeaderBar";
import Country from "../commons/model/address/Country";
import SelectableOption from "../commons/model/SelectableOption";

interface TeamSupportProps {
  countries: Country[];
  teams: Team[];
  onTeamSelected: (team: Team) => void;
}

interface TeamSupportState {
  displayAddTeamModal: boolean;
}

export default class TeamSupport extends React.Component<TeamSupportProps, TeamSupportState> {
  constructor(props: TeamSupportProps) {
    super(props);
    this.state = {
      displayAddTeamModal: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.showAddTeamModal = this.showAddTeamModal.bind(this);
  }

  render() {
    const addTeamButton = (
      <a id="add-team-button" className="button-primary" onClick={this.showAddTeamModal}>
        {i18n["Page.CustomerSupport.AddTeam"]}
      </a>
    );
    const content =
      this.props.teams.length == 0 ? (
        <div className="container">
          <div className="message-container">
            {i18n["Page.CustomerSupport.NoTeam.Title"]}
            <a className="link" onClick={this.showAddTeamModal}>
              {i18n["Page.CustomerSupport.NoTeam.Action"]}
            </a>
          </div>
        </div>
      ) : (
        <>
          <HeaderBar title={i18n["Page.CustomerSupport.TeamSupportTitle"]} action={addTeamButton} />
          <TeamCards
            teams={this.props.teams}
            onTeamSelected={this.props.onTeamSelected}
            countries={this.props.countries}
          />
        </>
      );

    return (
      <>
        <div className="team-support-container">{content}</div>
        {this.state.displayAddTeamModal && (
          <ModalAddTeam
            countries={this.props.countries.map(
              (country) => new SelectableOption(country.name, country.i18n, false)
            )}
            close={this.closeModal}
          />
        )}
      </>
    );
  }

  private showAddTeamModal() {
    this.setState({ displayAddTeamModal: true });
  }

  private closeModal(reload: boolean) {
    if (reload) {
      document.location.reload();
    } else {
      this.setState({ displayAddTeamModal: false });
    }
  }
}
